import { useEffect, useState } from "react";
import { Input } from "../../../ui/input";
import ChangePhoneModal from "./modals/changeNumberPhone";
import Button from "../../../ui/button";
import useAuthUserPatch from "../../../../api/hooks/hooks-auth/use-auth-patch-user";
import useMe from "../../../../api/hooks/use-user-me";
import styles from "./styles.module.scss";
import useOpenModal from "../../../ui/modal/hooks/useOpenModal";

interface IUserFormData {
  firstName: null | string;
  lastName: null | string;
  patronymic: null | string;
  email: null | string;
  phone: null | string;
}

const USER_FORM_DATA = {
  firstName: null,
  lastName: null,
  patronymic: null,
  email: null,
  phone: null,
};

const PersonalInfo = () => {
  const { offsetY, open, handleChangeModal } = useOpenModal();

  const [userFormData, setUserFormData] =
    useState<IUserFormData>(USER_FORM_DATA);

  const handleChange = (key: keyof IUserFormData, data: string) => {
    setUserFormData((prev) => ({ ...prev, [key]: data }));
  };

  const {
    data,
    error: errorUserPath,
    isMutating,
    trigger,
  } = useAuthUserPatch();

  const { me, error: errorMe, isLoading, mutate } = useMe();

  useEffect(() => {
    if (me) {
      setUserFormData({
        firstName: me.firstName ?? "",
        lastName: me.lastName ?? "",
        patronymic: me.patronymic ?? "",
        email: me.email ?? "",
        phone: me.phone ?? "",
      });
    }
  }, [JSON.stringify(me)]);

  const refetchMe = async () => {
    await mutate();
  };

  const handleSaveInfo = async () => {
    await trigger({
      firstName: userFormData.firstName ? userFormData.firstName : "",
      lastName: userFormData.lastName ? userFormData.lastName : "",
      email: userFormData.email ? userFormData.email : undefined,
      patronymic: userFormData.patronymic ? userFormData.patronymic : undefined,
    });
    await refetchMe;
  };

  return (
    <div className={styles.personalInfo}>
      <div className={styles.personalInfo__container}>
        <div className={styles.personalInfo__title}>
          Персональная информация:
        </div>
        <div className={styles.personalInfo__fio}>
          <Input
            label="Фамилия"
            onChange={(value) => handleChange("lastName", value)}
            placeholder="Например: Иванов"
            value={userFormData.lastName}
            isMainPlaceholder
          />
        </div>
        <div className={styles.personalInfo__fio}>
          <Input
            label="Имя"
            onChange={(value) => handleChange("firstName", value)}
            placeholder="Например: Иван"
            value={userFormData.firstName}
            isMainPlaceholder
          />
        </div>
        <div className={styles.personalInfo__fio}>
          <Input
            label="Отчество"
            onChange={(value) => handleChange("patronymic", value)}
            placeholder="Например: Иванович"
            value={userFormData.patronymic}
            isMainPlaceholder
          />
        </div>
        <div className={styles.personalInfo__email}>
          <Input
            label="email"
            onChange={(value) => handleChange("email", value)}
            placeholder="Например: email@gmail.com"
            value={userFormData.email}
            isMainPlaceholder
          />
        </div>
        <div
          className={styles.personalInfo__phone}
          onClick={() => handleChangeModal(true)}
        >
          <Input
            label="телефон"
            readOnly
            value={userFormData.phone}
            isMainPlaceholder
          />
        </div>
        <div className={styles.personalInfo__buttons}>
          <Button label="Сохранить" onClick={handleSaveInfo} />
        </div>
      </div>

      <ChangePhoneModal
        offsetY={offsetY}
        refetch={refetchMe}
        onClose={(value) => handleChangeModal(value)}
        opened={open}
      />
    </div>
  );
};

export default PersonalInfo;
